import { render, staticRenderFns } from "./peiBuList.vue?vue&type=template&id=44f47185&scoped=true&"
import script from "./peiBuList.vue?vue&type=script&lang=js&"
export * from "./peiBuList.vue?vue&type=script&lang=js&"
import style0 from "./peiBuList.vue?vue&type=style&index=0&id=44f47185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f47185",
  null
  
)

export default component.exports